// src/components/GroupIntake/transformers/facility-transformer.js
/**
 * Transforms a frontend facility structure to match the backend schema
 * Ensures required fields are properly placed at the root level as expected by the backend
 */
export function transformFacilityForApi(facility) {
  // Create a deep copy to avoid modifying the original
  const transformedFacility = JSON.parse(JSON.stringify(facility));
  
  // Move nested properties to root level as required by backend schema
  if (transformedFacility.facilityDetails) {
    // Move facilityType to root (required field)
    if (transformedFacility.facilityDetails.facilityType) {
      transformedFacility.facilityType = transformedFacility.facilityDetails.facilityType;
    } else {
      // Default value for required field
      transformedFacility.facilityType = 'hospital';
    }
    
    // Move other facilityDetails fields to root if they exist
    if (transformedFacility.facilityDetails.traumaLevel) {
      transformedFacility.traumaLevel = transformedFacility.facilityDetails.traumaLevel;
    }
    
    if (transformedFacility.facilityDetails.teamModel) {
      transformedFacility.teamModel = transformedFacility.facilityDetails.teamModel;
    }
    
    // Remove the facilityDetails object since its fields are now at root level
    delete transformedFacility.facilityDetails;
  } else {
    // Ensure required field exists
    transformedFacility.facilityType = transformedFacility.facilityType || 'hospital';
  }
  
  // Handle name field (required by backend)
  if (!transformedFacility.name && transformedFacility.facilityName) {
    transformedFacility.name = transformedFacility.facilityName;
  } else if (!transformedFacility.name) {
    transformedFacility.name = 'New Facility';
  }
  
  // Ensure location exists (required by backend)
  if (!transformedFacility.location) {
    transformedFacility.location = 'TBD';
  }
  
  // Other transformations can be added here as needed
  
  return transformedFacility;
}
